import {typography} from 'material-ui/styles';

const styles = {
    rightIcon: {
        first: {
            position: 'absolute',
            right: 10
        },
        second: {
            position: 'absolute',
            right: 45
        },
        third: {
            position: 'absolute',
            right: 85
        }
    },
    dropzone: {
        container: {
            border: '1px dashed black',
            borderRadius: '10px',
            padding: '10px',
            marginLeft: '15px',
            marginRight: '15px',
            textAlign: 'center'
        },
        loading: {
            textAlign: 'left',
            marginBottom: '20px',
            fontSize: 16,
            fontWeight: typography.fontWeightLight,
        },
        title: {
            fontSize: 18,
            fontWeight: typography.fontWeightNormal,
        },
        subtitle: {
            fontSize: 16,
            fontWeight: typography.fontWeightLight,
        }
    },
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300
    },
    mapFull: {
        height: '80vh'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/openexplore/TrailPage/TrailPage.css.js